import React, { useEffect, useState } from "react";
import { FaChevronDown } from "react-icons/fa";

interface ExpandableProps {
  header: React.ReactNode;
  children: React.ReactNode;
  defaultExpanded?: boolean;
  forceExpanded?: boolean;
  className?: string;
}

const Expandable: React.FC<ExpandableProps> = ({
  header,
  children,
  defaultExpanded = false,
  forceExpanded,
  className = "",
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  useEffect(() => {
    if (forceExpanded !== undefined) {
      setIsExpanded(forceExpanded);
    }
  }, [forceExpanded]);

  return (
    <div className={className}>
      <button
        onClick={() => {
          setIsExpanded(!isExpanded);
        }}
        className="w-full flex items-center justify-between text-left focus:outline-none group"
        aria-expanded={isExpanded}
      >
        <div className="flex-1">{header}</div>
        <FaChevronDown
          className={`ml-2 text-gray-400 group-hover:text-white transition-all duration-300 ${
            isExpanded ? "rotate-180" : "rotate-0"
          }`}
          size={14}
        />
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          isExpanded ? "max-h-[1000px] opacity-100 mt-3" : "max-h-0 opacity-0"
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default Expandable;
